module.exports = __webpack_public_path__ + "img/profel-logo.png";